import AllFeaturesSearch from './AllFeaturesSearch'

export default AllFeaturesSearch
